/* eslint-disable */
// import { approvalMap, warning } from '../examples'
import { getWorkflowNoteInfo } from 'api/flow'
import Vue from 'vue'
const $t = Vue.prototype.$t

// 枚举值选项
var radioInfo = []
getWorkflowNoteInfo().then(res => {
  radioInfo = res.data
})
/**
 * @description 条件组回显逻辑
 * @param { Object } item
 * @returns { String }
 */
export const handlerBranch = item => {
  // 节点和条件分支数据结构不同
  const currentData = item.form
  // 条件组循环
  const arr = currentData.map(element => {
    // 条件循环
    const conditions = element.map(current => {
      const { condition, operator, value } = current
      const state = condition && operator && value && operator.name
      if (state) {
        return `${condition.name}  ${operator.name}  ${value.name || value.value}  `
      }
    })
    // 输出数组转字符串
    return conditions.toString().replaceAll(',', $t('work_rule_31'))
  })
  // 输出数组转字符串
  return arr.toString().replaceAll(',', ' ' + $t('work_rule_32') + ' ')
}

/**
 * 审批人以及cc节点的处理
 * @param {*} form 当前节点form
 * @param {*} type 当前节点类型
 * @returns string
 */
const approvalCcMethods = (form, type) => {
  const dataForm = type === 1 ? form.auditor : form.cc
  if (dataForm) {
    const labels = dataForm.map(item => {
      // 获取label 值参考上方radioInfo
      const res = radioInfo.filter(el => el.type === item.settype)
      const key = res[0]?.label || ''
      if (!key) return ''
      // 格式化返回
      const isArray = Array.isArray(item.val)
      // 数组处理
      if (isArray) {
        return `${key}: ${item.val.map(params => params.label).toString()}`
      }
      // 对象或字符串
      return `${key}: ${typeof item.val === 'object' ? item.val.label : item.val}`
    })
    return labels?.toString()
  }
}

// 根据不同类型解析
const mapFormate = new Map([[1, approvalCcMethods], [2, approvalCcMethods], [(3, handlerBranch)]])
/**
 * 数据格式化处理 如果不存在则返回空字符串
 * @param {*} currentNode 当前节点数据
 * @returns
 */
const methods = currentNode => {
  const { form, type } = currentNode
  if (!form) return ''
  const fn = mapFormate.get(type)
  return fn ? fn(form, type) : ''
}

/**
 * 节点回显
 * @param {*} obj
 * @returns {String}
 */
export const showData = obj => {
  // 区分类型 0 发起人 1 审批人 2抄送人 3条件分支
  return methods(obj)
}
